import styled from './Animation.module.scss';

export const TRANSITION_TIMEOUT = 250;

/** Классы для анимированного появления/иcчезновения компонента */
export const TRANSITION_CLASSES = {
  appear: styled.rootEnter,
  appearActive: styled.rootEnterActive,
  enter: styled.rootEnter,
  enterActive: styled.rootEnterActive,
  exit: styled.rootExit,
  exitActive: styled.rootExitActive,
};
